export default "__VITE_ASSET__CMAnPaT1__"